const getHostname = (url) => {
  try {
    return new URL(url).hostname;
  } catch (e) {
    return "";
  }
};
const isRelativeUrl = (url) => !/^http|^\/\//.test(url);
export {
  getHostname,
  isRelativeUrl
};
//# sourceMappingURL=UrlUtils.js.map
